//import expand from "emmet";
import expand from "./emmet.es.js";

export function implode($c, $separator = ", ") {
  var $arr = [];

  if (!$c.length) return false;

  $c.forEach(function(entry) {
    $arr.push(entry);
  });

  return $arr.join($separator);
}
export function uniqueArray(arr) {
  var a = [];
  for (var i = 0, l = arr.length; i < l; i++)
    if (a.indexOf(arr[i]) === -1 && arr[i] !== "") a.push(arr[i]);
  return a;
}
export default function el($vyraz, $val = false) {
  if ($val && _.isArray($val)) {
    return expand($vyraz + "{" + implode($val, "") + "}");
  } else if ($val) {
    return expand($vyraz + "{" + $val + "}");
  } else {
    return expand($vyraz);
  }
}

class Fce {
  has(obj, key) {
    return key.split(".").every(function(x) {
      if (typeof obj != "object" || obj === null || !(x in obj)) return false;
      obj = obj[x];
      return true;
    });
  }

  get(obj, key) {
    return key.split(".").reduce(function(o, x) {
      return typeof o == "undefined" || o === null ? o : o[x];
    }, obj);
  }
  getDataLayer() {
    var c = window.dataLayer || false;
    if (!c) return false;

    return this.get(c, "0.Ladzo");
  }
  escapeHtml(unsafe) {
    return unsafe
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }
  nl2br(str) {
    if (typeof str === "undefined" || str === null) {
      return "";
    }
    var breakTag = "<br>";
    return (str + "").replace(
      /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
      "$1" + breakTag + "$2"
    );
  }
  phoneLink(tel) {
    return "tel:" + tel.replaceAll(" ", "");
  }
  emailLink(email) {
    return "mailto:" + email;
  }
  menaEuro() {
    if (window.dataLayer[0]["shoptet"]["currency"] == "EUR") return true;
    return false;
  }
  vratMenu() {
    return window.getShoptetDataLayer("currency");
  }
  prevedFormatujDleMeny(price, kurz = true, mena = true) {
    if (kurz === true) {
      kurz = window.getShoptetDataLayer("currencyInfo").exchangeRate;
    }
    if (mena === true) {
      mena = window.getShoptetDataLayer("currency");
    }
    let c = kurz * price;
    //c = Math.round(c * 10) / 10;
    if (mena == "CZK") {
      //c = Math.round(c * 10) / 10;
      c = c.formatCisla(0, ".", " ") + " Kč";
    } else if (mena == "EUR") {
      c = "€" + c.formatCisla(1, ".");
    }

    Lc.log("meny", [price, kurz, mena, c]);
    return c;
  }
}

var MojeFce = new Fce();
export { MojeFce };

//var exports = {};
//exports.default = el;
